import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { Label } from 'reactstrap'



export default function Footer() {
  const [scrollPercentage, setScrollPercentage] = useState(0);
  const [isDisclaimer, setIsDisclaimer] = useState(false);
  useEffect(() => {
    const updateScrollPercentage = () => {
      const scrollPx = document.documentElement.scrollTop;
      const winHeightPx =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const scrolled = (scrollPx / winHeightPx) * 100;

      setScrollPercentage(scrolled);
    };

    window.addEventListener('scroll', updateScrollPercentage);

    return () => {
      window.removeEventListener('scroll', updateScrollPercentage);
    };
  }, []);

  useEffect(() => {
    let time = null;
    const getData = async () => {
      const item = await localStorage.getItem('policy');
      console.log('policy from storage', item);
      if (!item)
        time = setTimeout(() => {
          setIsDisclaimer(true)
        }, 3000);
    }
    getData();
    return () => clearTimeout(time);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsDisclaimer(true);
      } else {
        setIsDisclaimer(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  const handleOkayDisclaimer = () => {
    setIsDisclaimer(false);
    localStorage.setItem('policy', 'agreed');
  }

  return (
    <footer className='footer padding-left-right' style={{ paddingTop: '50px' }}>

      <div className='container'>
        <div className='row'>
          <div className='col-lg-3 col-md-6'>
            <div className='footer-logo'>
              <img src={require("../assets/images/logo-cyber.png")} />
            </div>
          </div>
          <div className='col-lg-3 col-md-6'>
            <div className='footer-txt'>
              <p className='para_text1 d-flex'><i class="fa fa-envelope mt-2" aria-hidden="true"></i>&nbsp;<a href="mailto:info@cyberfortify.tech">info@cyberfortify.tech</a></p>
            </div>
          </div>
          <div className='col-lg-3 col-md-6'>
            <div className='footer-txt'>
              <p className='para_text1'><img src={require('../assets/images/uae.webp')} alt='' /><a href="tel:971501227432">&nbsp;+971-501227432</a></p>
            </div>
          </div>
          <div className='col-lg-3 col-md-6'>
            <div className='footer-col'>
              <div className="social-links">
                <li>
                  <a href="" target='_blank'><i className="fa-brands fa-facebook-f"></i></a>
                </li>
                <li>
                  <a href="" target='_blank'><i className="fa-brands fa-instagram"></i></a>
                </li>
                <li>
                  <a href="" target='_blank'><i className="fa-brands fa-linkedin-in"></i></a>
                </li>
                <li>
                  <a href="" target='_blank'><i className="fa-brands fa-twitter"></i></a>
                </li>
              </div>
            </div>
          </div>
        </div>
        <div className='divider_first'></div>
      </div>

      <div className='container mt-4'>
        <div className='row'>
          <div className='col-lg-3 col-md-6'>
            <div className='footer-item'>
              <h3 className='pl-2 mb-4'>Quick Links</h3>
              <div className='link-item pl-2'>
                <p><Link to="/">Home</Link></p>
                <p><Link to="/about">About Us</Link></p>
                <p><Link to="/contact-us">Contact Us</Link></p>
                <p><Link to="/services">Services</Link></p>
                <p><Link to="/career">Career</Link></p>
              </div>
            </div>
          </div>
          <div className='col-lg-3 col-md-6'>
            <div className='footer-item'>
              <h3 className='pl-2 mb-4'>Security Testing</h3>
              <div className='link-item pl-2'>
                <p><Link to="/services/network-penertration">NP Testing</Link></p>
                <p><Link to="/services/web-application-penetration">WAP Testing</Link></p>
                <p><Link to="/services/vulnerability-assessment">VAP Testing</Link></p>
                <p><Link to="/services/mobile-app">MAP Testing</Link></p>
                <p><Link to="/services/api-penetration">API Penetration Testing</Link></p>
              </div>
            </div>
          </div>
          <div className='col-lg-3 col-md-6'>
            <div className='footer-item'>
              <h3 className='pl-2 mb-4'>Cyber Risk</h3>
              <div className='link-item pl-2'>
                <p><Link to="/services/iso-27001">ISO 27001 Consulting</Link></p>
                <p><Link to="/services/sia-consulting">SIA(NESA) Consulting</Link></p>
                <p><Link to="/services/adhics-compliance">ADHICS Compliance</Link></p>
                <p><Link to="/services/uae-information">UAE IAR Audit</Link></p>
              </div>
            </div>
          </div>
          <div className='col-lg-3 col-md-6'>
            <div className='footer-item'>
              <h3 className='pl-2 mb-4'>Managed Services</h3>
              <div className='link-item pl-2'>
                <p><Link to="/services/managed-security">Manages Security</Link></p>
                <p><Link to="/services/security-operations">Security Operations Center</Link></p>
                <p><Link to="/services/annual-security">Annual Security Program</Link></p>
                <p><Link to="/privacy-policy">Privacy Policy</Link></p>
                <p><a href="/sitemap.xml">Sitemap</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="container p-0">
        <div className='row'>
          <div className="footer-col col-lg-3 col-md-6">
            <div className='footer-logo'>
              <img src={require("../assets/images/logo-w.png")} />
            </div>
            <h4>Cyber Fortify Technologies</h4>
            <ul className='mb-4'>
              <p>FF-24, Al Sayegh Building, Port Saeed, Dubai, United Arab Emirates</p>
            </ul>
          </div>
          <div className="footer-col col-lg-3 col-md-6">
            <h4>Quicklink</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/services">Security Testing</Link></li>
              <li><Link to="/services">Cyber Risk Management</Link></li>
              <li><Link to="/services">Managed Services</Link></li>
              <li><Link to="/contact-us">Contact Us</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </div>
          <div className="footer-col col-lg-3 col-md-6">
            <h4>More Services</h4>
            <ul>
              <li><Link to="/services/network-penertration">Network Penetration</Link></li>
              <li><Link to="/services/vulnerability-assessment">Vulnerability & Penetration</Link></li>
              <li><Link to="/services/iso-27001">ISO 27001</Link></li>
              <li><Link to="/services/security-operations">Security Operations</Link></li>
              <li><Link to="/adhics-compliance">ADHICS Compliance</Link></li>
              <li><Link to="/services/managed-security">Managed Security</Link></li>
            </ul>
          </div>
          <div className="footer-col col-lg-3 col-md-6">

            <div class="col-sm-12">
              <h4>Follows</h4>
              <ul>
                <li><a href="mailto:info@cyberfortify.tech">info@cyberfortify.tech</a></li>
                <li><a href="tel:971501227432">+971-501227432</a></li>
              </ul><br />
            </div>

            <div className="social-links">
              <li>
                <a href="#" target='_blank'><i className="fa-brands fa-facebook-f"></i></a>
              </li>
              <li>
                <a href="#" target='_blank'><i className="fa-brands fa-instagram"></i></a>
              </li>
              <li>
                <a href="#" target='_blank'><i className="fa-brands fa-linkedin-in"></i></a>
              </li>
              <li>
                <a href="#" target='_blank'><i className="fa-brands fa-twitter"></i></a>
              </li>
            </div>
          </div>
        </div>
      </div> */}

      <div className='container'>
        <div className='divider'></div>
        <div className='footer-copyright row'>
          <div className='col-lg-4 p-0'>
            <div className='copy-right-p'>
              <p> Copyright  &copy;2026 CYBER FORTIFY TECHNOLOGES </p>
            </div>
          </div>
        </div>
      </div>

      <div class="progress-circle-container">

        <svg viewBox="0 0 36 36" className="circular-chart">
          <path
            className="circle-bg"
            d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
          />
          <path
            className="circle"
            strokeDasharray={`${scrollPercentage}, 100`}
            d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
          />
        </svg>

        <div className="uparrow">
          <a href="#"><i className="fa fa-arrow-up"></i></a>
        </div>

      </div>
      <div className={isDisclaimer ? 'cookie-section active' : 'cookie-section'}>
        <div>
          <h4>Agree to cookies</h4>
          <p>"Cyber Fortify Technologies is a leading marketing agency based in UAE, specializing in innovative branding solutions tailored to elevate your business presence. With a strategic blend of creativity and analytics, we craft compelling narratives that resonate with your audience, driving impactful results."</p>
        </div>
        <button onClick={handleOkayDisclaimer}>OK, I got it</button>
      </div>
    </footer>
  )
}


